module.exports = __webpack_public_path__ + "img/delete-profile-ua.f9ddf6f2.png";